// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"57e9e389","943":"5237ca3d"}[chunkId] + ".chunk.css";
};